import { Color } from '@tiptap/extension-color';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import Highlight from '@tiptap/extension-highlight';
import ListItem from '@tiptap/extension-list-item';
import ListKeymap from '@tiptap/extension-list-keymap';
import Placeholder from '@tiptap/extension-placeholder';
import TextStyle from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit';

import {
    CustomClipboardExtension,
    CustomDocument,
    CustomLinkExtension,
    H1ManageExtension,
    HoverElementExtension,
    CustomDeleteExtension,
} from './customExtensions';

export const outlineEditorExtensions = [
    StarterKit.configure({
        bulletList: {
            keepMarks: true,
            keepAttributes: false,
        },
        orderedList: {
            keepMarks: true,
            keepAttributes: false,
        },
        document: false,
        dropcursor: false,
        bold: false,
        italic: false,
        underline: false,
        code: false,
        codeBlock: false,
        blockquote: false,
        horizontalRule: false,
    }),
    Placeholder.configure({
        placeholder: 'Start writing or paste your outline here…',
    }),
    Color.configure({ types: [TextStyle.name, ListItem.name] }),
    TextStyle.configure({ types: [ListItem.name] }),
    CustomDocument.configure({
        HTMLAttributes: {
            class: 'my-custom-paragraph',
        },
    }),
    Dropcursor.configure({
        width: 1,
        class: 'dropcursor-border',
    }),
    HoverElementExtension,
    CustomClipboardExtension.configure({
        replaceParagraphsWithBulletedList: true,
    }),
    H1ManageExtension,
    ListKeymap,
    CustomLinkExtension,
    Highlight.configure({ multicolor: true }),
    CustomDeleteExtension,
];
